export default __webpack_public_path__ + "static/media/icon_q.80467c77.svg";